var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classnames from 'classnames';
import React from 'react';
import { List, Popper } from '../../../component';
import { ToolDisplay } from '../utils';
import { ButtonForToolbar, getConfigVal } from './button';
// default 'down-start'，but 'right-start' in dropdown menu, auto just when in toolbarInline
var getDropdownDefaultDirection = function (isStatic, isVertical) {
    if (isStatic) {
        if (isVertical)
            return 'down-start';
        return 'right-start';
    }
};
var TOGGLE_DELAY = 150;
/**
 * Basic class of selectButton
 * there is no tooltip and showName in select button, provided by renderIcon
 * - @type {() => JSX.Element} renderIcon
 * - @type {() => JSX.Element} renderMenu
 * - @type {() => boolean} checkActive check if the button needs highlight
 */
var SelectBase = /** @class */ (function (_super) {
    __extends(SelectBase, _super);
    function SelectBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuRef = React.createRef();
        _this.shouldClose = false; // determine whether the menu should be hidden when the mouse moves
        _this.state = {
            open: false,
            tooltipShow: false,
        };
        _this.tendToCloseMenu = function (level) {
            if (level === void 0) { level = 1; }
            _this.shouldClose = true;
            setTimeout(function () {
                _this.shouldClose && _this.closeMenu();
            }, TOGGLE_DELAY / level);
        };
        _this.getTriggerHandler = function () {
            var triggerHandler = {};
            var _a = _this.props, toolbar = _a.toolbar, editor = _a.editor;
            if (toolbar && toolbar.disable && toolbar.disable(editor)) {
                return triggerHandler;
            }
            if (_this.eventType !== 'click') {
                triggerHandler.onMouseEnter = function () { return _this.openMenu(); };
                triggerHandler.onMouseLeave = function () { return _this.tendToCloseMenu(); };
            }
            else {
                triggerHandler.onClick = function (e) {
                    _this.state.open ? _this.closeMenu() : _this.openMenu();
                    e.stopPropagation();
                };
            }
            return triggerHandler;
        };
        _this.checkClose = function (e) {
            if (!_this.wrap || !_this.menuRef.current || !e.target)
                return;
            if (!_this.state.open)
                return;
            if (_this.menuRef.current.contains(e.target))
                return;
            _this.tendToCloseMenu(6);
        };
        _this.openMenu = function () {
            _this.shouldClose = false;
            if (_this.state.open)
                return;
            setTimeout(function () {
                _this.setState({ open: true, tooltipShow: false });
                document.addEventListener('scroll', _this.updatePosition);
                document.addEventListener('click', _this.checkClose, true);
            }, _this.eventType !== 'click' ? TOGGLE_DELAY / 2 : 0);
        };
        _this.closeCallBack = function () { };
        _this.closeMenu = function () {
            if (!_this.state.open)
                return;
            _this.setState({ open: false }, _this.closeCallBack);
            document.removeEventListener('scroll', _this.updatePosition);
            document.removeEventListener('click', _this.checkClose, true);
        };
        _this.updatePosition = function () { return requestAnimationFrame(function () { return _this.forceUpdate(); }); };
        _this.showTooltip = function () {
            if (!_this.state.open && !_this.state.tooltipShow) {
                _this.setState({ tooltipShow: true });
            }
        };
        _this.hideTooltip = function () {
            if (!_this.state.open && _this.state.tooltipShow) {
                _this.setState({ tooltipShow: false });
            }
        };
        _this.checkActive = function () { return false; };
        _this.renderIcon = function () { return React.createElement("span", null); };
        _this.renderMenu = function () { };
        _this.renderMenuList = function () {
            var _a;
            var _b = _this.props.toolbarType, toolbarType = _b === void 0 ? 'static' : _b;
            return (React.createElement(List, { className: classnames((_a = {},
                    _a[toolbarType] = toolbarType,
                    _a)), getRef: _this.menuRef, onClick: _this.closeMenu }, _this.renderMenu()));
        };
        return _this;
    }
    Object.defineProperty(SelectBase.prototype, "eventType", {
        get: function () {
            var _a = this.props, display = _a.display, trigger = _a.trigger, toolbarType = _a.toolbarType;
            if (trigger) {
                return trigger === 'click' ? 'click' : 'mousemove';
            }
            if (toolbarType === 'inline')
                return 'mousemove';
            if (display === ToolDisplay.VERTICAL)
                return 'click';
            return 'mousemove';
        },
        enumerable: false,
        configurable: true
    });
    SelectBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.name, name = _b === void 0 ? '' : _b, tooltip = _a.tooltip, editor = _a.editor, tipDirection = _a.tipDirection, _c = _a.tipDistance, tipDistance = _c === void 0 ? 4 : _c, _d = _a.toolbarType, toolbarType = _d === void 0 ? 'static' : _d, _e = _a.menuDistance, menuDistance = _e === void 0 ? 4 : _e, menuDirection = _a.menuDirection, toolbar = _a.toolbar, display = _a.display, showName = _a.showName;
        var _f = this.state, open = _f.open, tooltipShow = _f.tooltipShow;
        var isVertical = display === ToolDisplay.VERTICAL;
        var isStatic = toolbarType === 'static';
        var locale = editor.configurator.getLocaleValue(name);
        var renderName = !isVertical ? getConfigVal([showName, locale.showName, locale.tooltip, tooltip, name]) : false;
        return (React.createElement(ButtonForToolbar, { display: display, tipDirection: tipDirection, tipDistance: tipDistance, toolbarType: toolbarType, name: name, tooltip: isVertical ? tooltip : false, toolbar: __assign(__assign({}, toolbar), { showName: isVertical ? false : toolbar === null || toolbar === void 0 ? void 0 : toolbar.showName, icon: function () {
                    var _a;
                    return (React.createElement(Popper, { isOpen: Boolean(open), tipContentClassName: classnames((_a = {}, _a[name] = name, _a)), content: _this.renderMenuList(), distance: ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.menuDistance) || menuDistance) + (!isStatic && !isVertical ? -8 : 0), direction: menuDirection || (toolbar === null || toolbar === void 0 ? void 0 : toolbar.menuDirection) || getDropdownDefaultDirection(isStatic, isVertical) },
                        React.createElement("span", null, _this.renderIcon()),
                        !isVertical && renderName && React.createElement("span", { className: "tool-name" }, renderName)));
                } }), getRef: function (wrap) {
                _this.wrap = wrap;
            }, active: this.checkActive(), handler: function () { return (_this.state.open ? _this.closeMenu() : _this.openMenu()); }, editor: editor, attrs: false, tooltipProps: { isOpen: open ? false : tooltipShow }, buttonProps: __assign({ onMouseEnter: this.showTooltip, onMouseLeave: this.hideTooltip }, this.getTriggerHandler()), className: classnames('syl-toolbar-dropdown', { open: open }) }));
    };
    return SelectBase;
}(React.Component));
export { SelectBase };
//# sourceMappingURL=base.js.map